<template>
  <div>
    <v-row class="table_data ma-0">
      <v-col class="title">{{ $t('myapplication.myapplication_details.fields.application_type') }}</v-col>
      <v-col class="content"><span class="impt_text">{{ applicationType }}</span></v-col>
      <v-col class="title">{{ $t('myapplication.myapplication_details.fields.reception_date') }}</v-col>
      <v-col class="content">{{ biblio.receipt_date }}</v-col>
    </v-row>

    <v-row class="table_data ma-0">
      <v-col class="title">{{ $t('myapplication.myapplication_details.fields.application_number') }}</v-col>
      <v-col class="content">
        {{ biblio.application_no }}
        <span v-if="!(biblio.application_no)" style="color:#a01c2a;font-weight:bold;">({{ biblio.application_receipt_no }})</span>
      </v-col>
      <v-col class="title">{{ $t('myapplication.myapplication_details.fields.filing_date') }}</v-col>
      <v-col class="content">{{ biblio.filing_date }}</v-col>
    </v-row>

    <v-row class="table_data ma-0">
      <v-col class="title">{{ $t('myapplication.myapplication_details.fields.registration_number') }}</v-col>
      <v-col class="content">{{ biblio.grant_no }}</v-col>
      <v-col class="title">{{ $t('myapplication.myapplication_details.fields.registration_date') }}</v-col>
      <v-col class="content">{{ biblio.grant_date }}</v-col>
    </v-row>

    <v-row class="table_data type2 ma-0">
      <v-col cols="3" class="title mt-15">{{ $t('myapplication.myapplication_details.fields.title') }}</v-col>
      <v-col cols="9" class="content">
        <v-row>
          <v-col cols="12">
            <v-row class="ma-0 content_drop_type_wrap">
              <v-col cols="2" class="title_drop_type">
                <span class="impt_text">{{ $t('myapplication.myapplication_details.fields.arabic') }}</span>
              </v-col>
              <v-col cols="10" class="content_drop_type arabic_align">
                <p class="">{{ biblio.title_ar }}</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row class="ma-0 content_drop_type_wrap">
              <v-col cols="2" class="title_drop_type">
                <span class="impt_text">{{ $t('myapplication.myapplication_details.fields.english') }}</span>
              </v-col>
              <v-col cols="10" class="content_drop_type">
                <p>{{ biblio.title_en }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="table_data type2 ma-0">
      <v-col cols="3" class="title mt-15">{{ $t('myapplication.myapplication_details.fields.abstract') }}</v-col>
      <v-col cols="9" class="content">
        <v-row>
          <v-col cols="12">
            <v-row class="ma-0 content_drop_type_wrap">
              <v-col cols="2" class="title_drop_type">
                <span class="impt_text">{{ $t('myapplication.myapplication_details.fields.arabic') }}</span>
              </v-col>
              <v-col cols="10" class="content_drop_type arabic_align">
                <p v-html="biblio.abstract_ar"></p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row class="ma-0 content_drop_type_wrap">
              <v-col cols="2" class="title_drop_type">
                <span class="impt_text">{{ $t('myapplication.myapplication_details.fields.english') }}</span>
              </v-col>
              <v-col cols="10" class="content_drop_type">
                <p v-html="biblio.abstract_en"></p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="table_data type2 ma-0">
      <v-col cols="3" class="title mt-15">{{ $t('myapplication.myapplication_details.fields.exhibition_name') }}</v-col>
      <v-col cols="9" class="content">
        <v-row>
          <v-col cols="12">
            <v-row class="ma-0 content_drop_type_wrap">
              <v-col cols="2" class="title_drop_type">
                <span class="impt_text">{{ $t('myapplication.myapplication_details.fields.arabic') }}</span>
              </v-col>
              <v-col cols="10" class="content_drop_type arabic_align">
                <p>{{ biblio.exhibition_name_ar }}</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row class="ma-0 content_drop_type_wrap">
              <v-col cols="2" class="title_drop_type">
                <span class="impt_text">{{ $t('myapplication.myapplication_details.fields.english') }}</span>
              </v-col>
              <v-col cols="10" class="content_drop_type">
                <p>{{ biblio.exhibition_name_en }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="table_data ma-0">
      <v-col class="title">{{ $t('myapplication.myapplication_details.fields.opening_date') }}</v-col>
      <v-col class="content"><span class="impt_text">{{ biblio.exhibition_opening_date }}</span></v-col>
      <v-col class="title">{{ $t('myapplication.myapplication_details.fields.end_date') }}</v-col>
      <v-col class="content">{{ biblio.exhibition_end_date }}</v-col>
    </v-row>

    <h2 class="m_title">{{ $t('myapplication.myapplication_details.fields.applicants') }}</h2>
    <v-data-table
      :headers="$getHeaderType1(headerTxt1, headers1)"
      :items="list1"
      hide-default-footer
      disable-pagination
      class="new__type__table__view"
      :mobile-breakpoint="MobileBreakPoint"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>
            <p>{{item.name_ar}}</p>
            <p>{{item.name_en}}</p>
          </td>
          <td>
            <p>{{item.address_ar}}</p>
            <p>{{item.address_en}}</p>
          </td>
          <td>{{item.nationality_code}}</td>
          <td>{{item.residence_country_code}}</td>
          <td>
            <p>{{item.applicant_type_name_ar}}</p>
            <p>{{item.applicant_type_name_en}}</p>
          </td>
        </tr>
      </template>
    </v-data-table>



    <h2 class="m_title">{{ $t('myapplication.myapplication_details.fields.inventors') }}</h2>
    <v-data-table
      :headers="$getHeaderType1(headerTxt2, headers2)"
      :items="list2"
      hide-default-footer
      disable-pagination
      class="new__type__table__view"
      :mobile-breakpoint="MobileBreakPoint"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>
            <p>{{item.name_ar}}</p>
            <p>{{item.name_en}}</p>
          </td>
          <td>
            <p>{{item.address_ar}}</p>
            <p>{{item.address_en}}</p>
          </td>
          <td>{{item.nationality_code}}</td>
          <td>{{item.residence_country_code}}</td>
        </tr>
      </template>
    </v-data-table>

    <h2 class="m_title">{{ $t('myapplication.myapplication_details.fields.representative') }}</h2>
    <v-data-table
      :headers="$getHeaderType1(headerTxt3, headers3)"
      :items="list3"
      hide-default-footer
      disable-pagination
      class="new__type__table__view"
      :mobile-breakpoint="MobileBreakPoint"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>
            <p>{{item.name_ar}}</p>
            <p>{{item.name_en}}</p>
          </td>
          <td>
            <p>{{item.address_ar}}</p>
            <p>{{item.address_en}}</p>
          </td>
          <td>{{item.nationality_code}}</td>
          <td>{{item.residence_country_code}}</td>
          <td>
            <p>{{ item.agent_type_name_ar }}</p>
            <p>{{ item.agent_type_name_en }}</p>
          </td>
        </tr>
      </template>
    </v-data-table>

  </div>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
export default {
  props: {
    biblio: {
      type: Object
    },
    applicationType: {
      type: String
    }
  },
  data () {
		return {
      MobileBreakPoint : 0,
      headerTxt1 : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code', 'applicant_type' ]
      },
      headers1: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('myapplication.myapplication_details.fields.name'), align: 'center', value: 'name', width: '250' },
        { text: this.$t('myapplication.myapplication_details.fields.address'), align: 'center', value: 'address' },
        { text: this.$t('myapplication.myapplication_details.fields.nationality_country_code'), align: 'center', value: 'natcc', width: '80' },
        { text: this.$t('myapplication.myapplication_details.fields.residence_country_code'), align: 'center', value: 'rdcc', width: '80' },
        { text: this.$t('myapplication.myapplication_details.fields.applicant_type'), align: 'center', value: 'applicant_type_code', width: '120' },
      ],
      headerTxt2 : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code' ]
      },
      headers2: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('myapplication.myapplication_details.fields.name'), align: 'center', value: 'name', width: '250' },
        { text: this.$t('myapplication.myapplication_details.fields.address'), align: 'center', value: 'address' },
        { text: this.$t('myapplication.myapplication_details.fields.nationality_country_code'), align: 'center', value: 'natcc', width: '100' },
        { text: this.$t('myapplication.myapplication_details.fields.residence_country_code'), align: 'center', value: 'rdcc', width: '100' },
      ],
      headerTxt3 : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code', 'agent_type' ]
      },
      headers3: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('myapplication.myapplication_details.fields.name'), align: 'center',value: 'name', width: '250' },
        { text: this.$t('myapplication.myapplication_details.fields.address'), align: 'center',value: 'address' },
        { text: this.$t('myapplication.myapplication_details.fields.nationality_country_code'), align: 'center',value: 'rdcc', width: '100' },
        { text: this.$t('myapplication.myapplication_details.fields.residence_country_code'), align: 'center',value: 'natcc', width: '100' },
        { text: this.$t('myapplication.myapplication_details.fields.agent_type'), align: 'center',value: 'agent_type_code', width: '150' }
      ],
      headerTxt4 : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'name','address' ]
      },
      headers4: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('myapplication.myapplication_details.fields.name'), align: 'center',value: 'name', width: '250' },
        { text: this.$t('myapplication.myapplication_details.fields.address'), align: 'center',value: 'address' },
      ],
      list1 : [],
      list2 : [],
      list3 : [],


    }
  },
  mounted(){
    this.fnGetApplicants()
    this.fnGetInventors()
    this.fnGetRepresentatives()
  },
  methods : {
    fnGetApplicants(){
      requestApi({
        url: '/applications/' + this.biblio.seq + '/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.list1 = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicants()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetInventors(){
      requestApi({
        url: '/applications/' + this.biblio.seq + '/inventors',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.list2 = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetInventors()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetRepresentatives(){
      requestApi({
        url: '/applications/' + this.biblio.seq + '/representatives',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.list3 = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetRepresentatives()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

  }
}
</script>